var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsFixit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_fixit_group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons_fixit_group2",
    transform: "translate(-1109.000000, -513.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons_fixit_group3",
    transform: "translate(1109.250000, 513.250000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.163700421,10.2169115 L5.32643042,5.0228852 C4.81583075,3.71010932 5.09949723,2.16902459 6.17742987,1.08455756 C7.3120958,-0.0569866884 9.0140947,-0.285295537 10.3756938,0.342553797 L7.93616206,2.79687392 L9.63816096,4.50919029 L12.134426,2.05487016 C12.8152256,3.42472326 12.5315591,5.13703962 11.3968932,6.27858387 C10.3189605,7.3630509 8.78716151,7.64843696 7.48229569,7.13474205 L2.31956569,12.3287684 C2.09263251,12.5570772 1.75223273,12.5570772 1.52529954,12.3287684 L0.220433718,11.0159925 C-0.0632327652,10.7876836 -0.0632327652,10.3881431 0.163700421,10.2169115 Z",
    id: "icons_fixit_path1"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFixit);
export default __webpack_public_path__ + "static/media/icons_fixit.a5324043.svg";
export { ForwardRef as ReactComponent };